import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import { COMPANY_ABBREVIATION_REGEX } from '@acceligentllc/shared/constants/regex';

import type { CompanyFormModel } from './form';

export function validate(values: CompanyFormModel) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Company name is required';
	}

	if (!isValidTextInput(values.abbreviation)) {
		errors.abbreviation = 'Company Abbreviation is required';
	} else if (!COMPANY_ABBREVIATION_REGEX.test(values.abbreviation)) {
		errors.abbreviation = 'Company abbreviation can have up to 8 alphanumeric characters.';
	}

	if (!isValidTextInput(values.street)) {
		errors.street = 'Location is required';
	}

	if (!values.timezone) {
		errors.timezone = 'Timezone is required';
	}

	if (!values.latitude) {
		errors.latitude = 'Latitude is required';
	}

	if (!values.longitude) {
		errors.longitude = 'Longitude is required';
	}

	if (
		values?.latitude
		&& (values.latitude > 90 || values.latitude < -90)
	) {
		errors.latitude = 'Latitude is not valid';
	}

	if (
		values?.longitude
		&& (values.longitude > 180 || values.longitude < -180)
	) {
		errors.longitude = 'Longitude is not valid';
	}

	return errors;
}
